module.exports = __webpack_public_path__ + "static/media/arrow_right_black.a514284d.svg";